import React from "react";
import { Clock } from "lucide-react";
import { format } from "date-fns";

/**
 * Displays the activity log of tracking updates
 */
export function TrackingActivityLog({ updates }) {
  return (
    <div className="border border-border p-6">
      <h2 className="font-bold mb-4">Activity Log</h2>
      {updates?.length > 0 ? (
        <div className="space-y-3">
          {[...updates].reverse().map((update, index) => (
            <div key={`${update.timestamp}-${index}`} className="flex gap-3 pb-3 border-b border-border last:border-0 last:pb-0">
              <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center shrink-0">
                <Clock className="w-4 h-4 text-muted-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm">{update.status}</p>
                <p className="text-xs text-muted-foreground truncate">{update.message}</p>
                <p className="text-xs text-muted-foreground mt-1">
                  {format(new Date(update.timestamp), "h:mm a, MMM d")}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground text-center py-4 text-sm">No updates yet</p>
      )}
    </div>
  );
}
